exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-item{display:inline-flex;align-items:center}", ""]);

// exports
